import React, { useContext } from "react";
import styles from "./MoreStory.module.scss";
import PathContext from "../../context/path";
import MobileContext from "../../context/mobile";
import { Link, useMatch } from 'react-router-dom';
import SliderBtn from '../SliderBtn/SliderBtn';

const MoreStory = (props) => {
  const { color, type } = props;
  const path = useContext(PathContext);
  const isMobile = useContext(MobileContext);
  const persons = {
    'story-svetlana': {
      'img': 'sveta-mini',
      'name': 'Светлана',
      'text': 'История планомерного карьерного роста'
    },
    // 'story-alexandra': {
    //   'img': 'alexandra-mini',
    //   'name': 'Александра',
    //   'text': 'О роли команды Р-Фарм в достижении целей'
    // },
    'story-evgenia': {
      'img': 'evgenia-mini',
      'name': 'Евгения',
      'text': 'О свободе жить, действовать, мечтать'
    },
    // 'story-felix': {
    //   'img': 'felix-mini',
    //   'name': 'Феликс',
    //   'text': 'О мечте работать в фармаконадзоре'
    // },
    'story-dmitry': {
      'img': 'dmitri-mini',
      'name': 'Дмитрий',
      'text': 'О работе в Китае, России и Германии'
    },
    'story-ekaterina': {
      'img': 'ekaterina-mini',
      'name': 'Екатерина',
      'text': 'Как энтузиазм и команда превращают идеи в систему'
    }
  };
  const linkArray = [
    'story-svetlana',
    // 'story-alexandra',
    'story-evgenia',
    // 'story-felix',
    'story-dmitry',
    'story-ekaterina',
  ];
  const useCurrentPath = () => {
    const id = useMatch('/:id');

    if (id !== null && id.params.id !== undefined) {
      return id.params.id;
    }
    return 'main';
  }
  const currentPath = useCurrentPath().toLowerCase();

  let list = [];
  let btnClass = 'blue_plus_to_green';
  let linkClass = `${styles.link}`;

  switch (color) {
    case 'blue_plus':
      linkClass += ` ${styles.link_blue_plus}`;
      break;
    case 'blue_dark':
      btnClass = 'blue_dark_to_green';

      linkClass += ` ${styles.link_blue_dark}`;
      break;
    case 'purple':
      btnClass = 'purple_to_green';

      linkClass += ` ${styles.link_purple}`;
      break;
    case 'red':
      btnClass = 'red_to_green';
      linkClass += ` ${styles.link_red}`;
      break;
    case 'green':
      btnClass = 'green_to_pink';
      linkClass += ` ${styles.link_green_light}`;
      break;
    case 'green_invite':
      btnClass = 'green_invite';
      linkClass += ` ${styles.link_green_invite}`;
      break;
    case 'green_secondary':
      btnClass = 'green-secondary_to_pink';
      linkClass += ` ${styles.link_green_secondary}`;
      break;

    default:
      break;
  }

  let btn = <Link to={{ pathname: `../about`, search: window.location.search }} className={styles.btn}>
    <SliderBtn text={'Подробнее о компании'} color={btnClass} />
  </Link>;
  if (isMobile && type !== 'vacancy') {
    btn = null;
  };
  if (isMobile) {
    linkClass += ` ${styles.link_mobile}`;
  };

  if (isMobile) {
    let currentIndex = linkArray.indexOf(currentPath);
    let nextIndex = currentIndex < linkArray.length - 1 ? currentIndex + 1 : 0;
    let key = linkArray[nextIndex];
    // if(type === 'vacancy'){

    //   linkClass += ` ${styles.link_vacancy}`;

    //   btnClass += ` ${styles.link_vacancy}`;
    // }

    let link = <Link to={{ pathname: `../${key}`, search: window.location.search }} key={`more-link-${key}`} className={linkClass}>
      <div className={styles.img}>
        <img src={`${path}/img/${persons[key].img}.webp`} srcSet={`${path}/img/${persons[key].img}@2x.webp 2x`} alt="" />
      </div>
      <span>{type !== 'vacancy' ? 'Читать следующую историю' : 'Истории сотрудников'}</span>
    </Link>;
    list.push(link);
  } else {
    for (const key in persons) {
      if (key !== currentPath) {
        let link = <Link to={{ pathname: `../${key}`, search: window.location.search }} key={`more-link-${key}`} className={styles.link}>
          <div className={styles.img}>

            <picture>
              <source media="(min-width: 1921px)" srcSet={`${path}/img/${persons[key].img}@2x.webp`} />
              <img src={`${path}/img/${persons[key].img}.webp`} srcSet={`${path}/img/${persons[key].img}@2x.webp 2x`} alt="" />
            </picture>
          </div>
          <div className={styles.hidden}>
            <div className={styles.name}>{persons[key].name}</div>
            <div className={styles.text}>{persons[key].text}</div>
          </div>
        </Link>;
        list.push(link);
      }
    }
  }


  return (
    <>
      <div className={type === 'vacancy' ? `${styles.wrap} ${styles.wrap__vacancy}` : styles.wrap}>
        <h4>{type === 'vacancy' ? 'Читайте истории сотрудников' : 'Читайте еще истории'}</h4>
        {isMobile && type === 'vacancy' ?
          <div className={styles.title}>Узнайте больше <br /> о Р-Фарм </div>
          : null
        }
        <div className={styles.row}>
          <div className={styles.list}>
            {list}
          </div>
          {btn}

        </div>
      </div>
    </>
  );

}

export default MoreStory;
